import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import {
  quoteColumnHeaderSx,
  quoteFooterSx,
  quoteHeadingSx,
  quoteModalSx,
  StyledTableCell,
} from './IntegratedFreightShippingFragment.styles';
import { QuoteFreightOrderTypeResponse } from '../../../../../@types/shipment.type';
import { Button, ButtonVariantProps } from '../../../../../components/atoms/Button';
import { CloseIcon } from '../../../../../components/atoms/CloseIcon';
import { Modal } from '../../../../../components/atoms/Modal';

export interface FreightQuoteModalProps {
  open: boolean;
  onClose: () => void;
  quoteData: QuoteFreightOrderTypeResponse[];
}

const COLUMNS = ['Carrier', 'Service Code', 'Total Price ($)'];

export const FreightQuoteModal: React.FC<FreightQuoteModalProps> = ({
  open,
  onClose,
  quoteData,
}) => (
  <Modal open={open} aria-labelledby="freight-quote-modal-title">
    <Box sx={quoteModalSx}>
      <CloseIcon handleClose={onClose} />
      <Typography id="freight-quote-modal-title" component="h2" sx={quoteHeadingSx}>
        Quote
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            {COLUMNS.map((column) => (
              <StyledTableCell key={column} align="left">
                <Typography sx={quoteColumnHeaderSx}>{column}</Typography>
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {quoteData.map((row) => (
            <TableRow key={`${row.carrier_name}-${row.service_code}`}>
              <StyledTableCell align="left">
                <Typography sx={{ fontSize: '13px' }}>{row.carrier}</Typography>
              </StyledTableCell>
              <StyledTableCell align="left">
                <Typography sx={{ fontSize: '13px' }}>{row.service_code}</Typography>
              </StyledTableCell>
              <StyledTableCell align="left">
                <Typography sx={{ fontSize: '13px' }}>{row.total_price}</Typography>
              </StyledTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box sx={quoteFooterSx}>
        <Button variant={ButtonVariantProps.Secondary} onClick={onClose}>
          Close
        </Button>
      </Box>
    </Box>
  </Modal>
);
